import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import "core-js/modules/es.string.link.js";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import { Button, RaiseColors, Typography, makeStyles, useTheme } from "componentLibrary";
import React from "react";
import { Link } from "react-router";
import { WorkplaceOSLoginContainer, useWorkplaceOSLoginStyles, WorkplaceOSLoginHeader, WorkplaceOSLoginError, WorkplaceOSLoginTerms } from "./WorkplaceOSLoginCommon";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var useStyles = function useStyles() {
  var theme = useTheme();
  return makeStyles(function () {
    return {
      link: {
        textDecoration: "none",
        marginTop: 32,
        paddingBottom: 8
      },
      loginButton: {
        marginBottom: "16px",
        width: "100%"
      },
      loginText: {
        paddingLeft: "8px"
      },
      logo: {
        width: 30,
        height: 30
      }
    };
  });
};
var WorkplaceAlternateSignIns = function WorkplaceAlternateSignIns(_ref) {
  var isError = _ref.isError,
    errorMessage = _ref.errorMessage,
    additionalFormLinks = _ref.additionalFormLinks,
    alternateSignInMethods = _ref.alternateSignInMethods,
    setView = _ref.setView;
  var classes = useStyles()();
  var commonClasses = useWorkplaceOSLoginStyles();
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    disabled = _React$useState2[0],
    setDisabled = _React$useState2[1];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(WorkplaceOSLoginContainer, {
      children: [/*#__PURE__*/_jsx(WorkplaceOSLoginHeader, {
        title: "Sign in",
        onBack: function onBack() {
          return setView("check_email");
        }
      }), isError && /*#__PURE__*/_jsx(WorkplaceOSLoginError, {
        message: errorMessage
      }), alternateSignInMethods === null || alternateSignInMethods === void 0 ? void 0 : _mapInstanceProperty(alternateSignInMethods).call(alternateSignInMethods, function (method) {
        return /*#__PURE__*/_jsxs(Button, {
          variant: "newSecondaryBroker",
          onClick: function onClick() {
            method.onClick();
            setDisabled(true);
          },
          className: classes.loginButton,
          disabled: disabled,
          children: [/*#__PURE__*/_jsx("img", {
            src: method.imgSrc,
            className: classes.logo
          }), /*#__PURE__*/_jsx(Typography, {
            variant: "paragraph_large",
            weight: "medium",
            className: classes.loginText,
            children: method.label
          })]
        }, method.idp);
      }), additionalFormLinks && _mapInstanceProperty(additionalFormLinks).call(additionalFormLinks, function (link) {
        return /*#__PURE__*/_jsx("div", {
          className: classes.link,
          children: /*#__PURE__*/_jsx(Link, {
            to: link.to,
            className: commonClasses.linkText,
            children: /*#__PURE__*/_jsx(Typography, {
              color: RaiseColors.blue700,
              variant: "paragraph_medium",
              weight: "medium",
              children: link.label
            })
          })
        }, link.id);
      })]
    }), /*#__PURE__*/_jsx(WorkplaceOSLoginTerms, {})]
  });
};
export default WorkplaceAlternateSignIns;